var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("grid-condition", {
        attrs: { title: _vm.coTitle, parameter: _vm.coParameter },
        on: {
          "update:parameter": function($event) {
            _vm.coParameter = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "base-infinity-loading",
        {
          attrs: {
            pagination: _vm.pagination,
            activityStatus: _vm.activityStatus,
            parameter: _vm.coSearchParameter,
            source: _vm.blocks,
            "on-fetch": _vm.storeGetBlocks,
            "reset-before-destroy": _vm.storeResetBlocks,
            "set-loader-state": _vm.setListLoaderState
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(row) {
                return _c(
                  "v-flex",
                  {
                    ref: "blockRef",
                    staticClass: "pa-4",
                    staticStyle: { transition: "all 0.5 !important" },
                    style: _vm.dtStyle,
                    attrs: { xs3: "" }
                  },
                  [_c("grid-item", { attrs: { source: row.data } })],
                  1
                )
              }
            }
          ])
        },
        [
          _c("template", { slot: "loader" }, [
            _c(
              "div",
              { staticClass: "loader-container ml-4 mt-4" },
              [_c("grid-loader")],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a1f03c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a1f03c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-grid/template.html
// module id = null
// module chunks = 